import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import { AsYouType } from 'libphonenumber-js';

const PhoneField = (props) => {
  const phoneFormatter = new AsYouType(props.countryHint || 'US');

  function normalizePhoneFormatting(newValue, previousValue) {
    if (!newValue) {
      return '';
    }
    const newNumber = newValue.replace(/\D/g, '');
    const oldNumber = previousValue ? previousValue.replace(/\D/g, '') : '';
    if (oldNumber === newNumber) {
      return newValue;
    }
    phoneFormatter.reset();
    return phoneFormatter.input(newValue);
  }

  /*  The normalizePhoneFormatting method can change the value in the input field.
      This has different effects on the cursor position depending on the browser/device.
      This method runs before the normalize function, and is used to set the desired cursor
      position once the normalization formatting is applied.
    */
  function onChange(event) {
    const ref = event.target;
    const cursorAtEnd = ref.value.length === ref.selectionStart;
    const currentCursor = ref.selectionStart;
    setTimeout(() => {
      if (cursorAtEnd) {
        ref.setSelectionRange(ref.value.length, ref.value.length);
      } else {
        ref.setSelectionRange(currentCursor, currentCursor);
      }
    }, 20);
  }

  return (
    <Field
      component={ TextField }
      name="phoneNumber"
      floatingLabelText="Phone number"
      fullWidth={ true }
      validate={ props.validate }
      onChange={ onChange }
      normalize={ normalizePhoneFormatting }
    />
  );
};

PhoneField.propTypes = {
  validate: PropTypes.func,
  countryHint: PropTypes.string,
};

export default PhoneField;